module.exports = __webpack_public_path__ + "img/columns.8eec4b91.svg";